var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 100 125",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)",
    stroke: "green",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m69.794 49.283c-0.23284-1.5482-0.6337-2.3555-1.0322-2.6913-4.4836-3.7783-17.473-15.698-20.592-29.362-0.75549-3.3108-0.26645-6.5569-1.2615-9.7744-0.4975-1.0725-4.4775-5.7368-8.9551 1.2344-4.4775 6.9713 0.99501 28.421 0.99501 28.421s1.119 2.4123-10.854 2.3631c-1.8546-0.0076155-5.0663-4e-7 -6.5588-4e-7 -1.99 0-9.4526 1.3906-8.9551 7.2894 0.4975 5.8988 5.97 6.435 5.97 6.435s-8.9551 1.0725-8.9551 6.435c0 5.3625 9.9501 8.0438 9.9501 8.0438s-8.9551 1.0725-7.4625 8.0438c1.4925 6.9713 9.4526 5.3625 9.4526 5.3625s-4.975 3.3795-3.98 7.5075c0.99501 4.1281 2.985 5.8988 10.945 6.435 7.96 0.53625 41.309-4.452 41.309-10.351 0-3.2175 0.42552-28.104 0.39012-30.167 0 0-0.07853-3.0456-0.40646-5.2261z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.864,
    y: 45.338,
    width: 20.54,
    height: 41.958,
    rx: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumb);
export default __webpack_public_path__ + "static/media/thumb.c70c620d4c9e145fd18202b34cebd34b.svg";
export { ForwardRef as ReactComponent };